import React, { useEffect } from "react";
import "./style.scss";
import AccountDataPanel from "./AccountDataPanel";
import useMyAccount from "./hooks/useMyAccount";
import AccountDocPanel from "./AccountDocPanel";
import AccountCardPanel from "./AccountCard/AccountCardPanel";
import { useSelector } from "react-redux";
import { State } from "../../store";
import qs from "qs";
import { useNavigate } from "react-router";
import { goToPreviousPage } from "../../../utils/goToPreviousPage";
import { LOGIN_PAGE } from "../../routes";

const MyAccount: React.FC = () => {
  const ecardActive = useSelector((state: State) => state.config.configuration.ecard_showCode);
  useMyAccount();

  const queryParams = qs.parse(window.location.search.slice(1));
  const navigate = useNavigate();

  useEffect(() => {
    if (queryParams.redirect) {
      if (queryParams.redirect === "previousPath") {
        goToPreviousPage(navigate, LOGIN_PAGE);
      }
    }
    //eslint-disable-next-line
  }, []);

  return (
    <div className="panel-account">
      <AccountDataPanel />
      <div className="body-content flex-between">
        <div className={ecardActive === true ? "ticket-box shadow border" : "full-ticket-box ticket-box shadow border"}>
          <AccountDocPanel />
        </div>
        {ecardActive && (
          <div className="card-box shadow border">
            <AccountCardPanel />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyAccount;
